export interface BusinessInfoBiEnrichment {
    completionPercentage: number;
}

export const isBusinessInfoBiEnrichment = (
    biEnrichment: Record<string, any>
): biEnrichment is BusinessInfoBiEnrichment => typeof biEnrichment.completionPercentage === 'number';

export interface BuyerProfileCompletionResponseData {
    data: {
        percentage: number;
    };
}
